module.exports = __webpack_public_path__ + "img/content6-3.2a019b4b.webp";